const EventType = {
  ACTION: 'ACTION',
  NOTIFICATION: 'ALERT',
  WORKFLOW: 'WORKFLOW',
};

Object.freeze(EventType);

export default EventType;
